export const enClientPortalThreadOverviewPagePages = {
    threadOverviewPage: {
        title: 'Conversations',
        filters: {
            noResults: 'No conversations found for this order',
        },
        selection: {
            newConversation: 'New conversation',
            item: {
                noTitle: 'No title',
                notifiedUsersTooltip: 'No one is currently notified about new messages. Click here to add notified users.',
                options: 'Options',
                unpin: 'Unpin conversation',
                pin: 'Pin conversation',
                delete: 'Delete conversation',
            },
        },
        createDialog: {
            title: 'New conversation',
            create: 'Create',
            cancel: 'Cancel',
            topicLabel: 'Title *',
            participantsLabel: 'Add more notified users...',
            defaultNotifiedUsers: 'Default notified users for this new conversation:',
            yourself: 'You',
            creator: 'Creator',
            observers: 'Observers',
            assignees: 'Assignees',
            observersDescriptionSuffix: 'of the order, including',
        },
        emptyState: {
            loadingTitle: 'Conversations are loading...',
            emptyTitle: 'No open conversations',
            emptyDescriptionLineOne: 'Start a new conversation to ask questions, get support,',
            emptyDescriptionLineTwo: 'or share information with other users.',
            newConversation: 'New conversation',
        },
        orderDropdown: {
            loading: 'Loading order data...',
            label: 'Order',
            noOptions: 'No orders found',
            valuationDate: 'Valuation date',
            orderDate: 'Order date',
        },
        thread: {
            noMessages: 'No messages',
            deletedMessage: 'Message was deleted',
            createdBy: 'Conversation was created by {{userName}}',
            createdAutomatically: 'The conversation was created automatically',
        },
    },
}
